module.exports = __webpack_public_path__ + "static/media/smartsound_CINEMATIC_HIT_High_Metal_Click_01.f6637d69.wav";